import About from '@/components/About';
import Layout from '@/components/Layout';
About.getLayout = function getLayout(page) {
  return (
    <Layout webViewMobile={true} web="about">
      {page}
    </Layout>
  );
};

export default About;
